import { createFileRoute, Link } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { ListingsSection } from '~/features/listings/components/listings-section'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'
import { PageHeader } from '~/widgets/page-header'
import { PlacesUsageCard } from '~/widgets/places-usage-card'

export const Route = createFileRoute('/dashboard/listings/')({
  component: PlacesPage,
})

function PlacesPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title={m.listings()}
        action={
          <Button asChild>
            <Link to="/setup/profile" search={{ kind: 'place' }}>
              <Plus />
              {m.newPlace()}
            </Link>
          </Button>
        }
      />
      <PlacesUsageCard />
      <ListingsSection />
    </div>
  )
}
